import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay } from 'swiper/modules';
import { MdRemoveRedEye } from 'react-icons/md';
import animaker from '../../assets/img/animaker-project.png';
import holidaysunlocked from '../../assets/img/holidayunlockproject.jpg';
import dettydec from '../../assets/img/dettydecemberproject.jpg';
import ambiwance from '../../assets/img/ambiwancewaxproject.jpg';
import cyberwise from '../../assets/img/cyberwiseproject.jpg';
import promptgraphy from '../../assets/img/promptgraphyproject.jpg';
import modena from '../../assets/img/modenaproject.jpg';
import buyCex from '../../assets/img/buycex-project.png';
import signature from '../../assets/img/signature-project.png';
import stockswishlist from '../../assets/img/stocksplusproject.jpg';
import neptune from '../../assets/img/naptuneproject.jpg';
import infused from '../../assets/img/infusedproject.jpg';
import setium from '../../assets/img/seosparkproject.jpg';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Projects = () => {
  const projectsData = [
    {
      image: holidaysunlocked,  // or holidaysUnlockedImg
      color: '#DC2626',
      heading: 'HolidaysUnlocked',
      paragraph:
        "<strong>Holidays Unlocked</strong> is a modern travel booking platform that lets users search and book flights, hotel stays, car rentals, and activities worldwide with exclusive deals, flexible cancellations, and real-time pricing<br><br>" +
        "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • API integrations (flights/hotels/car data) • Responsive design • Newsletter/Forms handling",
      liveLink: 'https://holidaysunlocked.com/',
    }, {
      image: cyberwise,  // your imported image variable (e.g., laptop mockup of the site)
      color: '#8D26E5',  // Deep blue – professional cybersecurity/trust vibe (or change to '#1E3A8A' for darker navy)
      heading: 'CyberWise',
      paragraph:
        "<strong>CyberWise</strong> is a comprehensive cybersecurity platform that protects digital assets and empowers teams with expert consultations, realistic phishing simulations, in-depth team training, 24/7 real-time monitoring, thorough security audits, and compliance support tailored to business needs.<br><br>" +
        "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • API integrations (if any backend) • Responsive design • Counter animations • Forms/Newsletter handling • Modern JavaScript",
      liveLink: 'https://cyber-wise-fyp.vercel.app/',
    }, {
      image: dettydec,
      color: '#E0A627',  // Your golden/yellow vibe – perfect for energetic events/parties
      heading: 'Detty December',
      paragraph:
        "<strong>Detty December</strong> is an event discovery platform that helps users explore the best parties, concerts, festivals, and lifestyle experiences. It brings together curated events, venues, blogs, and exclusive perks to make planning unforgettable moments simple and engaging.<br><br>" +
        "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • Event listing & filtering • Dynamic content • Forms/Newsletter handling • Modern JavaScript",
      liveLink: 'https://dettydecember-nine.vercel.app/',
          },{
        image: buyCex,
        color: '#DFAB18',  // Your gold/yellow – great for crypto/energy vibe
        heading: 'BuyCex',
        paragraph: 
          "<strong>BuyCex</strong> is a publicly owned cryptocurrency exchange platform that enables users to trade top coins, participate in presales, earn rewards, and explore market movements with features like top gainers/losers lists, new listings, and seamless trading interfaces.<br><br>" +
          "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • API integrations (45+ backend endpoints) • Authentication & payment gateways • Responsive design • Real-time data handling • Modern JavaScript",
        liveLink: 'https://www.buycex.com/',
      },{
      image: promptgraphy,  // your imported image variable (e.g., screenshot of the homepage)
      color: '#000000',     // Indigo/purple – modern AI/tech vibe (or change to '#8B5CF6' for vibrant purple)
      heading: 'Promptgraphy',
      paragraph: 
        "<strong>Promptgraphy (BER AI)</strong> is an all-in-one AI-powered content creation platform that lets users generate high-quality text, stunning images, dynamic videos, and edit photos effortlessly. It supercharges workflows for content creators, marketers, and businesses with tools for SEO-friendly writing, hyperrealistic visuals, text-to-video conversion, image animation, and advanced photo enhancements.<br><br>" +
        "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • AI model integrations (ChatGPT, Claude, Gemini, Llama for text; FLUX.1 Schnell/Dev for images; Dream Machine for video) • Responsive design • Forms/Newsletter handling • Modern JavaScript",
      liveLink: 'https://ber-ai.vercel.app/',
    },
    {
      image: modena,
      color: '#A38219',  // Rich bronze/gold – luxurious real estate vibe
      heading: 'Modena Apartments',
      paragraph: 
        "<strong>Modena Apartments</strong> is a sleek real estate showcase platform highlighting modern investment apartments in Donovaly, offering carefree ownership with property management, passive income potential, and stunning nature surroundings. It includes detailed investment info (e.g., starting €90,000, 11.5% expected return), property features, gallery views, and easy contact/booking options for prospective buyers.<br><br>" +
        "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • Interactive gallery & counters • Forms/contact handling • Dynamic content • Modern JavaScript",
      liveLink: 'https://new-project-seven-gray.vercel.app/',
    },{
      image: ambiwance,
      color: '#E0A627',  // Warm gold/yellow – cozy, premium home/lifestyle feel
      heading: 'Ambiance Wax',
      paragraph: 
        "<strong>Ambiance Wax</strong> is a modern e-commerce platform showcasing premium wax products, scented candles, home ambiance items, and lifestyle goods. It features elegant product displays, curated collections, seamless browsing, and a user-friendly shopping experience to help customers discover and purchase items that enhance home warmth and relaxation.<br><br>" +
        "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • Product grids & collections • E-commerce features (cart/browse) • Dynamic content • Modern JavaScript",
      liveLink: 'https://ambiancewax-nine.vercel.app/',
    },
    {
  image: signature,
  color: '#4661E2',  // Professional blue – trust/business vibe, great for email tools
  heading: 'Email Signature Generator',
  paragraph: 
    "<strong>Email Signature Generator</strong> is a powerful Next.js full-stack tool that lets users create professional, branded email signatures in seconds. It features an intuitive editor for adding name, title, company, contact info, social links, logo/avatar upload, custom fields, color themes, and multiple templates, with real-time preview and easy HTML copy for Gmail, Outlook, Apple Mail, and more to boost brand consistency and lead generation.<br><br>" +
    "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • Real-time preview • File upload (logo/avatar) • Dynamic forms & templates • HTML generation • Modern JavaScript",
  liveLink: 'https://signature-generator-orpin.vercel.app/',
},
{
  image: stockswishlist,  // your imported image variable (e.g., screenshot of the dashboard or watchlist page)
  color: '#1F2937',      // Emerald green – finance/growth/success vibe (common in stock apps; or change to '#3B82F6' for blue trust)
  heading: 'Stocks Wishlist',
  paragraph: 
    "<strong>Stocks Wishlist</strong> is a modern finance tracking app that lets users create and manage personalized stock watchlists, monitor market performance, track price changes, and stay updated on favorite investments. It offers intuitive search for stocks, real-time or near-real-time data views, customizable lists, and easy addition/removal of symbols to simplify portfolio monitoring and informed decision-making for traders and investors.<br><br>" +
    "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • API integrations (stock data feeds if used) • Dynamic lists & tables • Charts/visualizations • Forms/search handling • Modern JavaScript",
  liveLink: 'https://stockswishlist.vercel.app/',
},
  {
  image: animaker,
  color: '#3236CD',  // Vibrant purple – creative/animation/energy vibe, matches your original
  heading: 'Animaker',
  paragraph: 
    "<strong>Animaker</strong> is a dynamic, animated landing page showcasing AI-powered video and animation creation tools. It delivers a vibrant user experience with lively animations, effortless content generation features (text-to-video, 2D animation, live-action elements), hero highlights for studio-quality results, and intuitive sections for non-designers and professionals to explore fast, flawless video making.<br><br>" +
    "<strong>Tech stacks:</strong> React.js • Tailwind CSS • GSAP/Framer Motion (for animations) • Responsive design • Dynamic hero & sections • Interactive elements • Modern JavaScript",
  liveLink: 'https://animakerjohn.vercel.app/',
},
{
  image: neptune,  // your imported image variable (e.g., screenshot of the homepage hero or features section)
  color: '#31484C',  // Sleek blue – modern SaaS/trust/professional vibe (matches common Neptune template tones; or use '#2563EB' for deeper blue)
  heading: 'Neptune SaaS',
  paragraph: 
    "<strong>Neptune SaaS</strong> is a premium, modern landing page template designed for SaaS platforms, startups, and agencies. It delivers a standout, professional website with sleek blue tones, dynamic sections for product features, benefits showcase, pricing plans, customer testimonials, integration highlights, and clear calls-to-action like 'Get Started' or 'Book a Demo' to drive conversions and user engagement.<br><br>" +
    "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • Animations/transitions • Hero & feature grids • Pricing tables • Testimonials carousel • Modern JavaScript",
  liveLink: 'https://neptune-saas-web.vercel.app/',
},
{
  image: setium,  // your imported image variable (e.g., screenshot of the homepage hero or features section)
  color: '#4E5078',  // Indigo/purple – modern tech/SaaS vibe (common for clean Vercel demos; or adjust to '#4F46E5' for deeper purple if the site uses it)
  heading: 'SEO SPARK',
  paragraph: 
    "<strong>SEO SPARK</strong> is a sleek, modern SaaS landing page template or demo designed for startups, tools, or digital products. It features a professional hero section with compelling headline and CTA, feature highlights in cards or grids, benefit-focused copy, testimonials or trust signals, pricing options, and intuitive navigation to showcase product value and drive user sign-ups or demos.<br><br>" +
    "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • Hero animations/transitions • Feature grids & cards • CTA buttons/forms • Modern JavaScript",
  liveLink: 'https://setium.vercel.app/',
},{
  image: infused,  // your imported image variable (e.g., screenshot of the hero or services section)
  color: '#42B6DF',  // Indigo/purple-blue – modern agency/creative/tech vibe (common for "infused" branding; adjust if your site uses a different dominant color)
  heading: 'Infused',
  paragraph: 
    "<strong>Infused</strong> is a sleek, modern landing page for a digital agency or creative services platform, empowering businesses to elevate their brand with infused strategies, innovative solutions, and high-impact web experiences. It features a compelling hero section with bold taglines, services showcase (e.g., web design, marketing, development), benefit highlights, client testimonials or case studies, seamless CTAs like 'Get Started' or 'Contact Us', and a clean, professional layout to drive leads and conversions.<br><br>" +
    "<strong>Tech stacks:</strong> React.js • Next.js • Tailwind CSS • Responsive design • Hero animations/transitions • Services/feature grids • Testimonials carousel • Forms/contact handling • Modern JavaScript",
  liveLink: 'https://infused-delta.vercel.app/',
},
  ];

  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const handleSlideChange = (swiper) => {
    setActiveSlideIndex(swiper.realIndex);
  };

  return (
    <div className='relative flex flex-col items-center justify-center w-full px-3 py-16 bg-white rounded-t-3xl bottom-10 gap-y-2'>
      <h6 className='text-[26px] sm:text-[32px] md:text-[40px] font-bold'>PROJECTS</h6>
      <div className='section-line'></div>
      <p className='text-[16px] md:text-[20px] w-[97%] sm:w-[90%] md:w-[65%] lg:w-[55%] xl:w-[42%] text-center text-[#555555]'>
        In <Link to='/my-projects' className='font-bold hover:text-black'>
          My Projects
        </Link>{' '}
        page, you will find some of the personal and clients projects that I created.
      </p>

      <div className='flex items-center flex-col-reverse lg:flex-row w-full justify-center gap-x-[48px] xl:gap-x-[70px] lg:w-[80%] py-5 lg:py-0'>
        {/* left */}
        <div className='flex items-center '>
          <Swiper
            slidesPerView={1}
            pagination={{ clickable: true }}
            navigation
            loop
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            modules={[Navigation, Pagination, Mousewheel, Keyboard, Autoplay]}
            onSlideChange={handleSlideChange}
            className='flex items-center justify-center w-[350px] sm:w-[450px] md:w-[580px]  '
          >
            {projectsData.map((project, index) => (
              <SwiperSlide key={index} className='flex items-center justify-center w-full'>
                <img src={project.image} alt={`Slide ${index + 1}`} className=' md:h-[380px] md:w-[521px]' />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* right */}
        <div className='flex flex-col items-start gap-y-3 w-[95%] sm:w-[70%] lg:w-auto lg:min-w-[380px]' >
          <div className={`text-2xl lg:text-3xl font-bold flex items-center gap-x-3`} >
            <h4 style={{ color: projectsData[activeSlideIndex].color }}>{projectsData[activeSlideIndex].heading}</h4>  <a
              href={projectsData[activeSlideIndex].liveLink}
              target="_blank" rel="noopener noreferrer"
              className='transition-all duration-300 ease-in-out hover:text-black hover:scale-125'
              title='Live'
            >
              <MdRemoveRedEye size={32} />
            </a>
          </div>

          <p
            dangerouslySetInnerHTML={{ __html: projectsData[activeSlideIndex].paragraph }}
            className='xl:w-[90%] text-[15px] lg:text-lg text-[#555555] leading-snug min-h-[83px]'
          ></p>
        </div>
      </div>
    </div>
  );
};

export default Projects;
